/* „Otvori u Google Maps" — linkovi, ne mapa.

   ── ŠTA OVO JESTE, A ŠTA NIJE ─────────────────────────────────────────────
   Ovo su OBIČNE ADRESE koje otvaraju Google u novoj kartici. NIJE poziv Google
   Maps Platform-a: ne traži API ključ, ne troši kvotu, ne naplaćuje se i ne
   zavisi ni od kakvog naloga.

   Google kao PODLOGA je namerno izbačen (10.09.2026) — mapa ostaje na
   OpenStreetMap-u, koji radi bez ključa i ne može da se ugasi zbog računa.
   Ali dispečeru i dalje treba da rutu ili tačku pošalje vozaču u Google
   navigaciju, pa linkovi ostaju. Podloga i navigacija su dve različite
   potrebe i rešavaju se odvojeno.

   Uslovi su ispoštovani baš zato što se Google sadržaj prikazuje u Google-ovoj
   aplikaciji, a ne na našoj Leaflet mapi. Isti pristup je već u
   Ture → Ruta vozača. */

const GOOGLE_TRAZI = 'https://www.google.com/maps/search/';
const GOOGLE_RUTA  = 'https://www.google.com/maps/dir/';

/* Maps URLs prima najviše devet međutačaka; u mobilnom pregledaču i manje.
   Preko toga Google tiho odbaci višak, pa se broj seče ovde da bi UI mogao da
   javi šta je izostavljeno. */
export const MAX_MEDJUTACAKA = 9;

const koordinata = (t) => `${Number(t.lat).toFixed(6)},${Number(t.lng).toFixed(6)}`;

/* Jedna tačka. Šalju se KOORDINATE, ne naziv: naziv sa naše mape Google ume da
   razreši na drugo mesto istog imena, a koordinata je nedvosmislena. */
export const googleLinkTacke = (tacka) => {
    if (!tacka || tacka.lat == null || tacka.lng == null) return null;
    const p = new URLSearchParams({ api: '1', query: koordinata(tacka) });
    return `${GOOGLE_TRAZI}?${p.toString()}`;
};

/* Ruta kroz dve ili više tačaka. `dir_action=navigate` na telefonu odmah kreće
   u navigaciju, na računaru samo otvara rutu — što je tačno ono što treba i
   dispečeru i vozaču, bez dva različita linka. */
export const googleLinkRute = (tacke, opcije = {}) => {
    const t = (tacke || []).filter(x => x && x.lat != null && x.lng != null);
    if (t.length < 2) return null;

    const p = new URLSearchParams({
        api: '1',
        origin: koordinata(t[0]),
        destination: koordinata(t[t.length - 1]),
        travelmode: 'driving',
        dir_action: 'navigate',
    });

    const medju = t.slice(1, -1).slice(0, MAX_MEDJUTACAKA);
    if (medju.length) p.set('waypoints', medju.map(koordinata).join('|'));
    if (opcije.izbegavajPutarine) p.set('avoid', 'tolls');

    return `${GOOGLE_RUTA}?${p.toString()}`;
};

/* Koliko je međutačaka ostalo izvan linka — panel to mora da kaže, jer ruta u
   Google-u tada nije ista kao ona na našoj mapi. */
export const izostavljenoTacaka = (tacke) =>
    Math.max(0, Math.max(0, (tacke || []).length - 2) - MAX_MEDJUTACAKA);

/* Trenutni pogled — isti isečak mape, samo kod Google-a.

   Jedini ulaz koji ne traži nikakav preduslov: ostali („otvori ovu tačku",
   „otvori izmerenu rutu", „otvori poziciju vozila") postoje tek kad nešto
   izabereš. Dispečer koji samo gleda mapu nema šta da izabere, pa mu treba
   ulaz koji stoji uvek.

   `/maps/@lat,lng,Nz` je Google-ov oblik za „pogled", ne za pretragu — otvara
   se isti deo sveta na istom uvećanju, bez pina i bez nametnutog rezultata. */
export const googleLinkPrikaza = (lat, lng, zum) =>
    `https://www.google.com/maps/@${Number(lat).toFixed(6)},${Number(lng).toFixed(6)},${Math.round(zum)}z`;

/* Otvaranje u novoj kartici. `noopener,noreferrer` je obavezan uz `_blank`:
   bez njega otvorena strana dobija pristup našem prozoru preko `window.opener`. */
export const otvoriGoogle = (veza) => {
    if (veza) window.open(veza, '_blank', 'noopener,noreferrer');
};

/* Međutačke iz naše trase — da Google prikaže BAŠ IZABRANU alternativu.

   Bez njih link nosi samo polazište i odredište, pa Google računa svoju rutu i
   pokaže ono što on smatra najboljim. To ume da bude druga trasa od one koju je
   dispečer izabrao — a izabrao ju je sa razlogom (manje radova, bez putarine).
   Vozač bi tada dobio rutu koju niko nije odabrao.

   Tačke se uzimaju ravnomerno po dužini niza, ne prvih devet: prvih devet bi
   svih devet potrošilo na prvih par kilometara, a ostatak puta ostavilo Google-u
   da pogađa. */
export const uzorakTrase = (geometrija, koliko = MAX_MEDJUTACAKA) => {
    /* Trasa stiže kao niz parova [lat, lng], ali se isti oblik koristi i sa
       objektima {lat, lng} — prihvataju se oba. */
    const tacka = (p) => (Array.isArray(p)
        ? { lat: Number(p[0]), lng: Number(p[1]) }
        : { lat: Number(p?.lat), lng: Number(p?.lng) });

    const g = (geometrija || []).map(tacka)
        .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));
    if (g.length < 3) return [];

    const unutra = g.slice(1, -1);
    if (unutra.length <= koliko) return unutra;

    const korak = unutra.length / (koliko + 1);
    const izbor = [];
    for (let i = 1; i <= koliko; i++) izbor.push(unutra[Math.floor(i * korak)]);
    return izbor;
};

/* Kopiranje u ostavu.

   `navigator.clipboard` postoji samo na https i localhost-u — aplikacija se u
   firmi otvara i preko obične http adrese u lokalnoj mreži, gde ga nema. Zato
   stara zamena preko skrivenog polja: `execCommand` jeste zastareo, ali je
   jedino što tamo radi, a tiho neuspešno kopiranje je gore od zastarelog API-ja. */
export const kopirajLink = async (veza) => {
    if (!veza) return false;

    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(veza);
            return true;
        }
    } catch (e) {
        /* pada na zamenu ispod */
    }

    try {
        const polje = document.createElement('textarea');
        polje.value = veza;
        polje.setAttribute('readonly', '');
        /* Van vidnog polja, ali NE `display:none` — skriveno polje se ne može
           označiti, pa kopiranje ne bi imalo šta da uzme. */
        polje.style.position = 'fixed';
        polje.style.top = '-1000px';
        document.body.appendChild(polje);
        polje.select();
        const uspelo = document.execCommand('copy');
        document.body.removeChild(polje);
        return uspelo;
    } catch (e) {
        return false;
    }
};
